module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAQAAAAOCAYAAAAIar0YAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAABeSURBVAiZvcuhDcJgFADh772gqhmCUToGgyDZA8EIpKl8oo50CIaAKsKPoYYBevIuF37cat6nNiVU1S61Kw4Ji+6EHmKoe0+M65qNM/HAG2ItQ80X2jH9sbn4vEI8vzwcF8bbwEdpAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/padImg/px1.png
// module id = Wsbw
// module chunks = 1